import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TextInput,
  CheckBoxInput,
  RadioInput,
} from "../../components/common/ui/Inputs";
import { PODAction } from "../../_store/pod.slice";
import podSchema from "../../validation/podSchema";

const PodInformation = ({ errorMessage, handleOnBlur }) => {
  const dispatch = useDispatch();
  const podData = useSelector((state) => state.pod?.managePODdata); // Access the form data from Redux
  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ];

  useEffect(() => {
    dispatch(PODAction.resetForm());
  }, []);

  const updatePODField = (name, value) => {
    // Create a shallow copy of podData

    if (value !== "" && value.trim() === "") {
      return;
    }
    const updatedPODData = { ...podData };

    //value = value?.trim();
    // Convert value to integer for specific fields if needed
    updatedPODData[name] = name === "ActiveStatus" ? parseInt(value) : value;

    // Dispatch action to update the POD data in Redux store
    dispatch(PODAction.setPODListData(updatedPODData));
  };

  const updatePODCheckboxValue = (e) => {
    const { name, checked } = e.target;

    // Use the spread operator to create a new PoDDataList object and update the checkbox value
    const updatedPODDataList = {
      ...podData,
      [name]: checked ? 1 : 0, // Convert checked to 1 or 0
    };

    // Dispatch the action to update the POD data in the Redux store
    dispatch(PODAction.setPODListData(updatedPODDataList));
  };

  return (
    <>
      <h4 className="inner-header-bg text-color">
        <i className="fa-solid fa-circle-info me-2"></i>POD Information{" "}
      </h4>
      <div className="p-2">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <div className="d-flex flex-wrap gap-3 align-items-center">
            {/* <Button
      label="Back"
      type="button"
      status="back"
      onClick={() => {
       history.navigate("PODList");
      }}
     /> */}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                id="PodCode"
                label="Code"
                name="PodCode"
                placeholder="Enter Code"
                value={podData?.PodCode} // Get value from Redux store
                handleChange={(e) => updatePODField("PodCode", e.target.value)}
                handleBlur={handleOnBlur}
                maxLength={10}
                required
                errorMessage={errorMessage}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="PodName"
                id="PodName"
                label="Name"
                placeholder="Enter Name"
                value={podData?.PodName} // Get value from Redux store
                handleChange={(e) => updatePODField("PodName", e.target.value)}
                maxLength={30}
                handleBlur={handleOnBlur}
                required
                errorMessage={errorMessage}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 mt-4">
            <CheckBoxInput
              label="Shared"
              name="SharedPod"
              id={"SharedPod"}
              checked={podData?.SharedPod} // Get value from Redux store
              handleClick={(e) => updatePODCheckboxValue(e)}
            />
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <CheckBoxInput
              label="Indefinite Kiosk Access"
              name="IsAllowedIndefiniteKioskAccess"
              id={"IsAllowedIndefiniteKioskAccess"}
              checked={podData?.IsAllowedIndefiniteKioskAccess} // Get value from Redux store
              handleClick={(e) => updatePODCheckboxValue(e)}
            />
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 mt-2">
            <div className="form-floating mb-1">
              <RadioInput
                name="ActiveStatus"
                id="ActiveStatus"
                label="Status"
                options={statusOptions}
                selectedValue={podData?.ActiveStatus} // Get value from Redux store
                handleChange={(e) =>
                  updatePODField("ActiveStatus", e.target.value)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(PodInformation);
